import { render } from "./OtpStep.vue?vue&type=template&id=4569a34c&scoped=true"
import script from "./OtpStep.vue?vue&type=script&lang=js"
export * from "./OtpStep.vue?vue&type=script&lang=js"

import "./OtpStep.vue?vue&type=style&index=0&id=4569a34c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4569a34c"]])

export default __exports__